export const fileExportStates = {
  requested: "Requested Export",
  queued: "Preparing Export",
  processing: "Preparing Export",
  completed: "Completed",
  failed: "Failed"
};
